import { CourseContentsScreen } from '@screens/CourseContentsScreen'

/**
 * Visão do produtor sobre o player da aula — paridade com
 * /admin_view/courses/:id/course_contents/:id do hero_theme.
 */
export default function AdminViewCourseContents() {
  return <CourseContentsScreen />
}
